import { extractPlotly } from './graph';

export interface Formatted {
  format: 'graph' | 'htmltable' | 'markdown' | 'text' | 'chart' | 'form' | string;
  dataToDisplay: Record<string, any>;
}

const tryParse = (v: any) => {
  if (typeof v === 'string') {
    try { return JSON.parse(v); } catch { return null; }
  }
  return v && typeof v === 'object' ? v : null;
};

export const formatAndConvertByType = (raw: any): Formatted => {
  if (!raw) return { format: 'text', dataToDisplay: { markdownString: '' } };

  
  const serverType: string | undefined = (raw.format || '').toString().toLowerCase() || undefined;

  
  if (serverType?.toLowerCase() === 'form' || serverType?.toLowerCase() === 'json') {
    if (raw.formJson && raw.formJson.fields) {
      return {
        format: 'form',
        dataToDisplay: {
          formFields: raw.formJson.fields,
          formTitle: raw.formJson.formName || 'Dynamic Form',
          formDescription: raw.formJson.currentSubsectionDescription || '',          
          formJson: raw.formJson,
          markdownString: raw.response || '' 
        }
      };
    }
  }

  
  if (serverType && (serverType.toLowerCase().includes("chart") || serverType.toLowerCase() === "graph")) {
    
    if (raw.structuredData && typeof raw.structuredData === 'object') {
      return {
        format: 'graph',
        dataToDisplay: {
          structuredData: raw.structuredData,
          markdownString: raw.response || '' 
        }
      };
    }
    
    
    if (raw.plotData || raw.data?.plotData) {
      return {
        format: 'graph',
        dataToDisplay: {
          plotData: raw.plotData || raw.data.plotData,
          layout: raw.layout || raw.data.layout,
          markdownString: raw.response || ''
        }
      };
    }
    
    
    if (typeof raw.structuredData === 'string') {
      try {
        const chartConfig = JSON.parse(raw.structuredData);
        return {
          format: 'graph',
          dataToDisplay: {
            plotData: chartConfig.data,
            layout: chartConfig.layout,
            markdownString: raw.response || ''
          }
        };
      } catch (error) {
        console.warn('Failed to parse structuredData JSON:', error);
      }
    }
  }

  // Table detection: explicit fields, structured data, or html snippet in reply
  //const tableHtml = raw.tableHtml || raw.table || (typeof raw.reply === 'string' && raw.reply.includes('<table') ? raw.reply : undefined);
  const structuredData = raw.structuredData;

  if (serverType && serverType?.includes('table')) {
    // Handle new API format with structured data
   // if (structuredData && structuredData.columns && structuredData.rows) {
      return {
        format: 'table',
        dataToDisplay: {
          columns: structuredData.columns,
          rows: structuredData.rows,
          responseText: raw.response || '',
          suppressTextContent: raw.suppressTextContent || false,          
        }
      };
    //}
    
    // Fallback to legacy HTML table format
    // return {
    //   format: 'table',
    //   dataToDisplay: {
    //    // tableHtml: tableHtml,
    //    // note: raw.note || raw.tableNote,
    //     responseText: raw.response || ''
    //   }
    // };
  }

  
  if (serverType === 'text') {
    const textResponse = raw.response || raw.reply || raw.answer || raw.result || '';
    return {
      format: 'text',
      dataToDisplay: { 
        markdownString: typeof textResponse === 'string' ? textResponse : String(textResponse)
      }
    };
  }

  
  const parsedData = tryParse(raw) || raw;
  const mdFromKnown = parsedData?.markDownResult
    ?? parsedData?.data?.markDownResult
    ?? raw?.markDownResult
    ?? raw?.data?.markDownResult;
  const reply = mdFromKnown ?? parsedData?.reply ?? raw?.answer ?? raw?.response ?? raw?.result ?? '';
  
  
  let markdownString = '';
  if (typeof reply === 'string') {
    markdownString = reply.replace(/<\/?Cell>/g, '');
  } else if (reply !== null && reply !== undefined) {
    
    markdownString = String(reply);
  }
  
  return {
    format: 'markdown',
    dataToDisplay: { markdownString }
  };
};
